/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Mb } from './Mb';

class MemberApplyNotice extends Mb {
    constructor() {
        super();
        this.baseUrl += '/memberApplyNotice';
    }

    getByCode({ code } = {}) {
        return super.get('/getByCode', {
            code,
        });
    }

    verticalGroupingSendMsg({ verticalGroupingId, sendType, template1, template2 }) {
        return super.post(
            '/verticalGroupingSendMsg',
            { verticalGroupingId, sendType, template1, template2 },
            {
                isHandleError: true,
                timeout: 0,
            },
        );
    }

    sendAdmitCardMsg({ verticalGroupingId }) {
        return super.post(
            '/sendAdmitCardMsg',
            { verticalGroupingId },
            {
                isHandleError: true,
                timeout: 0,
            },
        );
    }

    data({
        memberApplyNoticeName,
        memberApplyNoticeCode,
        noticePhase,
        noticeNode,
        isAvailable,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/data', {
            memberApplyNoticeName,
            memberApplyNoticeCode,
            noticePhase,
            noticeNode,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, memberApplyNoticeTemplate, isAvailable } = {}) {
        return super.post('/save', {
            id,
            memberApplyNoticeTemplate,
            isAvailable,
        });
    }

    isAvailableStatus({ id, isAvailable } = {}) {
        return super.post('/isAvailableStatus', {
            id,
            isAvailable,
        });
    }
}

export default new MemberApplyNotice();
export { MemberApplyNotice };
